import { ShieldAlert, X } from 'lucide-react';
import { useImpersonationStore } from '@/store/impersonation.store';

export function ImpersonationBanner() {
  const { user, superAdminEmail, stop } = useImpersonationStore();

  const exit = () => {
    stop();
    // window.close() only succeeds on a tab that was opened via script (which
    // this one always is, from the Businesses tab) — if it silently no-ops,
    // the fallback below just lands on a clean logged-out screen instead.
    window.close();
    window.location.href = '/login';
  };

  return (
    <div
      className="flex items-center gap-2.5 px-4 py-2 rounded-xl mb-4 text-xs font-semibold flex-wrap"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 40,
        background: 'linear-gradient(90deg, #7c3aed, #a855f7)',
        color: '#fff',
        boxShadow: '0 4px 16px rgba(124,58,237,0.35)',
      }}
    >
      <ShieldAlert className="w-4 h-4 shrink-0" />
      <span>
        Super Admin inspection — viewing as <strong>{user?.email ?? '…'}</strong>
        {user?.role ? ` (${user.role})` : ''}
        {user?.merchant?.name ? ` · ${user.merchant.name}` : ''}
      </span>
      {superAdminEmail && <span style={{ opacity: 0.8, fontWeight: 400 }}>by {superAdminEmail}</span>}
      <button
        type="button"
        onClick={exit}
        className="ml-auto flex items-center gap-1.5 px-2.5 py-1 rounded-full transition-colors"
        style={{ background: 'rgba(255,255,255,0.18)', border: '1px solid rgba(255,255,255,0.32)', color: '#fff' }}
      >
        <X className="w-3 h-3" /> Exit inspection
      </button>
    </div>
  );
}
